<form [formGroup]="formGroup">
    <app-form-field [type]="fields.name.type" [options]="fields.name.options"></app-form-field>

    <app-form-field [type]="fields.route.type" [options]="fields.route.options"></app-form-field>
    
    <app-form-field [type]="fields.type.type" [options]="fields.type.options"></app-form-field>

    <div class="row">
        <div class="col-md-6">
            <app-form-field [type]="fields.activeFrom.type" [options]="fields.activeFrom.options"></app-form-field>
        </div>
        <div class="col-md-6">
            <app-form-field [type]="fields.activeTo.type" [options]="fields.activeTo.options"></app-form-field>
            <small class="form-text text-danger" *ngIf="formGroup.controls.activeTo.errors">
                {{formGroup.controls.activeTo.errors.minDate.message}}
            </small>
        </div>
    </div>

    <ng-container *ngIf="formGroup.controls.type.value === 'video'">
        <app-form-field [type]="fields.url.type" [options]="fields.url.options"></app-form-field>
    </ng-container>
    <ng-container *ngIf="formGroup.controls.type.value === 'image'">
        <app-form-field [type]="fields.image.type" [options]="fields.image.options"></app-form-field>
    </ng-container>
    
    <app-form-field [type]="fields.active.type" [options]="fields.active.options"></app-form-field>
</form>

<div class="modal-footer">
    <button class="btn btn-success" (click)="submit()" [disabled]="!formGroup.valid"><i class="fa fa-save"></i> Guardar</button>
    <button class="btn btn-danger" (click)="modalRef.hide()"><i class="fa fa-times"></i> Cancelar</button>
</div>